import { RuleResult } from 'types/DeclarationP5'
import { hasText } from 'shared/lib/common-util'
import { LocationOfGoods } from '../../common/types'

const C0671Validator = {
  validateAdditionalIdentifierRequirement: ({
    locationOfGoods,
  }: {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    if (hasText(locationOfGoods?.authorisationNumber)) {
      return 'OPTIONAL'
    }
    return 'NOT_ALLOWED'
  },
} as const

export default C0671Validator
